import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { LangToCountryCodePipe } from '@personal-area/global/country';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pac-language-badge',
  templateUrl: './language-badge.component.html',
  styleUrls: ['./language-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, LangToCountryCodePipe, NgOptimizedImage],
})
export class LanguageBadgeComponent {
  @Input() language: string;
}
